import { useEffect, useState } from 'react';
import { getWeekDays, getWeekRange } from 'utils/getWeek';
import { last2Week } from 'components/Form/WeekRangePicker/utils';
import useSales from 'data/hooks/useSales';
import { toApiDayFormat } from 'utils/date';
import { HoverRange } from 'data/types/hoverRange';
import { Props } from './types';

const useConnect = ({ brandId }: Props) => {
  const hoverRangeDefault = {
    from: undefined,
    to: undefined,
  };
  const [hoverRange, setHoverRange] = useState<HoverRange>(hoverRangeDefault);
  const [selectedDays, setSelectedDays] = useState<Date[]>(
    getWeekDays(last2Week),
  );
  const handleDayChange = (date: Date) => {
    const days = getWeekDays(date);
    setSelectedDays(days);
  };
  const handleDayEnter = (date: Date) => {
    const days = getWeekRange(date);
    setHoverRange(days);
  };
  const handleDayLeave = () => {
    setHoverRange(hoverRangeDefault);
  };
  const handleWeekClick = (weekNumber: any, days: Date[]) => {
    setSelectedDays(days);
  };
  const { sales, isLoading, refetch } = useSales({
    brandId,
    dateStart: toApiDayFormat(selectedDays[0]),
    dateEnd: toApiDayFormat(selectedDays[6]),
  });
  const datesCopy = [...selectedDays];
  const firstDate = datesCopy.shift();
  const lastDate = datesCopy.pop();

  useEffect(() => {
    if (brandId !== '') {
      refetch();
    }
  }, [refetch, brandId, firstDate, lastDate]);

  return {
    hoverRange,
    selectedDays,
    handleDayChange,
    handleDayEnter,
    handleDayLeave,
    handleWeekClick,
    sales,
    isLoading,
  };
};

export default useConnect;
